module.exports = __webpack_public_path__ + "static/media/People Flow Toolkit.2b3cb233.png";